import * as React from 'react'
import {Box} from "@mui/material";

import {IconSeeker} from "@ui-seeker/core";


export default function activeColumn() {
    return [{
        name: 'isActive',
        label: 'Active',
        options: {
            display: 'excluded',
            customBodyRowRender: v => v ? 'Yes' : 'No'
        }
    },{
        name: 'isActive', label: 'Active',
        options: {
            filter: false,
            customBodyRowRenderLite: (value) => {
                const color = value ? 'success.lighter' : 'error.lighter'
                const icon = value ? 'square-check' : 'square-xmark'
                return <Box sx={{ textAlign: 'center', fontSize: 21 }}>
                    <IconSeeker icon={icon} sx={{ color: color }} />
                </Box>
            }
        }
    }]
}